import {BrowserModule} from '@angular/platform-browser';
import {ErrorHandler, Injector, NgModule} from '@angular/core';

import {AppComponent} from './app.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {AuthInterceptor} from './auth/auth.interceptor';
import {ErrorHandlerInterceptor} from './auth/errorhandler.interceptor';

import {CoreModule} from './core/core.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AppRoutingModule} from './app-routing.module';
import {GlobalErrorHandler} from './core/global-error-handler.service';

// import ngx-translate and the http loader
// import ngx-translate and the http loader
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HttpClient} from '@angular/common/http';
import { AuthModule, LogLevel, OidcSecurityService } from 'angular-auth-oidc-client';
import { environment } from '../environments/environment';
import { ApiMessageService } from './core/api-message.service';
import { NgxCnrUictSsoModule } from 'ngx-cnr-uict-sso';

@NgModule({ declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        NgxCnrUictSsoModule,
        AuthModule.forRoot({
            config: {
                authority: environment.oidc.authority || window.location.origin,
                redirectUrl: environment.oidc.redirectUrl || window.location.origin,
                postLogoutRedirectUri: environment.oidc.postLogoutRedirectUri || window.location.origin,
                clientId: environment.oidc.clientId || 'clientId',
                scope: 'openid profile email offline_access',
                responseType: 'code',
                silentRenew: true,
                useRefreshToken: true,
                ignoreNonceAfterRefresh: true,
                autoUserInfo: false,
                disableIatOffsetValidation: true,
                logLevel: LogLevel.None,
            },
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: CustomHttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        AppRoutingModule, // Routing
        CoreModule // Componenti moduli e servizi non Lazy
    ], providers: [
        {
            provide: ErrorHandler,
            useClass: GlobalErrorHandler
        }, {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
            deps: [Injector, OidcSecurityService]
        }, {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorHandlerInterceptor,
            multi: true,
            deps: [OidcSecurityService, ApiMessageService]
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }

// required for AOT compilation
export function CustomHttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
